export default __webpack_public_path__ + "static/media/logworks1.714cae7f.jpg";